import { BaseService } from './base-service'
import { Observable } from 'rxjs'
import { LoanAPIConstant } from '@/api/constant/loan'
import { LoanRequest, LoanResponse, CancelLoanRequest, QueryLoanInfoRequest, loanReviewWequest, LoanReviewResponse } from '@/api/model/loan'
import { Page } from '@/api/model/base'

export class LoanService extends BaseService {
    protected loanConstant: LoanAPIConstant
    constructor() {
        super()
        this.loanConstant = new LoanAPIConstant()
    }

    queryLoanPage(data: LoanRequest): Observable<Page<LoanResponse>> {
        return this.request(this.loanConstant.queryLoanPage(data))
    }

    cancelLoan(data: CancelLoanRequest): Observable<boolean> {
        return this.request(this.loanConstant.cancelLoan(data))
    }

    queryLoanInfo(data: QueryLoanInfoRequest): Observable<LoanResponse> {
        return this.request(this.loanConstant.queryLoanInfo(data))
    }

    loanReview(data: loanReviewWequest): Observable<LoanReviewResponse> {
        return this.request(this.loanConstant.loanReview(data))
    }
}
